import React from "react";
import { RCCPagination, RCCRefPaginationProps } from "react-common-components";
import IComponentPagination from "react-common-components/dist/components/Pagination/interface";
import { useTranslation } from "src/context/Translations/context";
import { css } from "styled-components";

const Pagination: React.ForwardRefRenderFunction<RCCRefPaginationProps,IComponentPagination> = ({ ...rest }, ref) => {
	const { translate } = useTranslation();
	return(
		<RCCPagination 
			ref={ref}
			messages={{
				warning: translate("Atenção"),
				error: translate("Erro ao tentar encontrar resultados para esta pesquisa"),
				noContent: translate("Não foram encontrados resultados para esta pesquisa"),
				toastError: {
					title: translate("Ocorreu um erro"),
					description: translate("Erro")
				},
				recordsPerPage: translate("Registros por página"),
				visualizing: {
					showing: translate("Mostrando"),
					of: translate("de"),
					in: translate("em"),
					pages: translate("páginas")
				},
				recordSelected: translate("registro selecionado"),
				recordsSelected: translate("registros selecionado"),
				print: translate("Exportar página atual"),
				printAll: translate("Exportar todas páginas")
			}}
			styleInline={rest.styleInline || {
				row: css`
					@media(max-width: 600px){
						>div:not(:last-child){
							justify-content: flex-start !important;
						}
					}
				`
			}}
			{...rest}
		/>
	);
};

export default React.forwardRef(Pagination);
